import { NullableChartPeriod } from "@components/Charts/CleanChart.control";
import { SHOW_LOGS } from "../config";

export namespace dev {
  export function log(text: string, ...obj: any) {
    if (SHOW_LOGS) {
      if (obj && obj.length > 0) {
        //console.trace();
        // console.log(new Date());
        console.log(text, ...obj);
      } else {
        console.log(text);
      }
    }
  }

  // чтоб в консоли фильтровать по тегу
  export function logt(tag: string, text: string, ...obj: any) {
    if (SHOW_LOGS) {
      if (obj && obj.length > 0) {
        //console.trace();
        // console.log(new Date());
        console.log(`${tag} : ${text}`, ...obj);
      } else {
        console.log(`${tag} : ${text}`);
      }
    }
  }

  export function logif(
    tag: string,
    text: string,
    predicate: () => boolean,
    ...obj: any
  ) {
    if (SHOW_LOGS && predicate()) {
      if (obj && obj.length > 0) {
        //console.trace();
        // console.log(new Date());
        console.log(`${tag} : ${text}`, ...obj);
      } else {
        console.log(`${tag} : ${text}`);
      }
    }
  }

  export function red(text: string, ...obj: any) {
    if (SHOW_LOGS) {
      if (obj && obj.length > 0) {
        //console.trace();
        // console.log(new Date());
        console.log(`%c ${text}`, 'color: #ff0000', ...obj);
      } else {
        console.log(`%c ${text}`, 'color: #ff0000');
      }
    }
  }

  export function green(text: string, ...obj: any) {
    if (SHOW_LOGS) {
      if (obj && obj.length > 0) {
        //console.trace();
        // console.log(new Date());
        console.log(`%c ${text}`, 'color: #00ff00', ...obj);
      } else {
        console.log(`%c ${text}`, 'color: #00ff00');
      }
    }
  }

  export function force(text: string, ...obj: any) { // чтобы даже на мейне показывать логи
    if (obj && obj.length > 0) {
      //console.trace();
      // console.log(new Date());
      console.log(text, ...obj);
    } else {
      console.log(text);
    }
  }

  export function trace(text: string, obj?: any) {
    if (SHOW_LOGS) {
      if (obj) {
        //console.trace();
        console.trace(text, ...obj);
      } else {
        console.trace(text);
      }
    }
  }

  export function error(text: string, obj?: any) {
    if (SHOW_LOGS) {
      if (obj) {
        console.error(text, ...obj);
      } else {
        console.error(text);
      }
    }
  }

  export function err(text: string, ...obj: any) {
    if (SHOW_LOGS) {
      console.error(text, ...obj);
    }
  }

  export function llog(text: string, ...obj: any) {
    if (SHOW_LOGS) {
      console.log(text, ...obj);
    }
  }

  export function periodToString(period: NullableChartPeriod) {
    let result = "[";
    if (period[0] !== null) {
      result += period[0].format("DD.MM.YYYY");
    } else {
      result += "null";
    }
    result += ",";
    if (period[1] !== null) {
      result += period[1].format("DD.MM.YYYY");
    } else {
      result += "null";
    }
    result += "]";
    return result;
  }
}
